import { SealCheckIcon, WarningIcon } from '@phosphor-icons/react';
import './budget_lighthouse.css';

/** O estado do farol, já em texto: `ok` (limite suficiente), `warning` (saldo abaixo
 *  do total, sem bloquear) ou `insufficient` (o servidor disse que não há limite). */
export type BudgetLighthouseProps =
  | { tone: 'ok' | 'warning'; text: string }
  | { tone: 'insufficient'; title: string; detail: string };

/** O semáforo de orçamento junto do rateio que ele reflete. Só exibe: nunca trava o
 *  envio — o servidor decide. */
export function BudgetLighthouse(props: Readonly<BudgetLighthouseProps>) {
  if (props.tone === 'insufficient') {
    return (
      <output className="bgl bgl--insufficient">
        <WarningIcon size={20} weight="fill" aria-hidden />
        <div className="bgl__text">
          <strong className="bgl__title">{props.title}</strong>
          <span className="bgl__detail">{props.detail}</span>
        </div>
      </output>
    );
  }
  const Icon = props.tone === 'ok' ? SealCheckIcon : WarningIcon;
  return (
    <output className={`bgl bgl--${props.tone}`}>
      <Icon size={20} weight="fill" aria-hidden />
      <span>{props.text}</span>
    </output>
  );
}
